import React, { useState, useEffect, useCallback } from 'react';
import '../../styles//crud.css';
import '../../styles//botones_dflt.css';
import Spinner from "../spinner";
import {ip_back , api_key} from '../../constants/appConstants';

const CrudTable = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // Estado para almacenar filas
  const [formData, setFormData] = useState({ usuario: '', email: '' ,nombre: '', apellido: '' ,identificacion: ''}); // Estado del formulario
  const [isFormModalOpen, setIsFormModalOpen] = useState(false); // Control del modal de ingreso/edición
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Control del modal de eliminación
  const [isResetPssdModalOpen, setIsResetPssdModalOpen] = useState(false); // Control del modal de reset pssd
  const [deleteIndex, setDeleteIndex] = useState(null); // Índice de la fila a eliminar
  const [isEditing, setIsEditing] = useState(false); // Estado para editar
  const [editIndex, setEditIndex] = useState(null); // Índice de la fila a editar
  const [resetpassIndex, setResetPassdIndex] = useState(null); // Índice de la fila para reset index
  const API_URL = ip_back + '/api/usuarios/obtener';

    // Cargar datos desde la API al montar el componente
    const fetchData = useCallback (async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(API_URL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
            Authorization: `Bearer ${token}`
          },
        });
        const json = await response.json();
        const formattedData = json.usuarios.map((item) => ({
          usuario: item.usuario,
          email: item.correo,
          nombre: item.nombres,
          apellido: item.apellidos,
          identificacion: item.cedula
        }));
        setData(formattedData);
        setLoading(false);
      } catch (error) {
        console.error('Error al cargar los datos:', error);
      }
    }, [API_URL]);

  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
      fetchData();
    }, [fetchData]); // Solo se ejecuta al montar el componente

  // Manejar los cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Abrir el modal de formulario para agregar o editar
  const openFormModal = (index = null) => {
    if (index !== null) {
      
      setFormData(data[index]); // Cargar datos existentes si es edición
      setIsEditing(true);
      setEditIndex(index);
    } else {
      setFormData({ usuario: '', email: '' ,nombre: '', apellido: '' ,identificacion: '' }); // Restablecer datos para nuevo ingreso
      setIsEditing(false);
    }
    setIsFormModalOpen(true);
  };

  // Cerrar el modal de formulario
  const closeFormModal = () => {
    fetchData();
    setIsFormModalOpen(false);
  };

  // Guardar datos (Agregar o Editar)
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    var API_URL = '';
    const token = JSON.parse(localStorage.getItem("token"));
    if (isEditing) {
      API_URL = ip_back + '/api/usuarios/modificar';
      try {
        const response = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "usuario" : formData.usuario, "correo" : formData.email ,"nombres" : formData.nombre, "apellidos" : formData.apellido, "cedula" : formData.identificacion, "editor" : storedUser}),
        });
  
        if (response.ok) {
          setIsFormModalOpen(false); // Cierra el modal
        } else {
          console.error('Error al guardar cambios:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    } else {
      API_URL = ip_back + '/api/usuarios/crear';
      try {
        const response = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "usuario" : formData.usuario, "correo" : formData.email ,"nombres" : formData.nombre, "apellidos" : formData.apellido, "cedula" : formData.identificacion, "contrasena": formData.usuario, 'creador': storedUser}),
        });
  
        if (response.ok) {
          setIsFormModalOpen(false); // Cierra el modal
        } else {
          console.error('Error al crear nuevo usuario:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    }
    closeFormModal();
  };

  // Abrir el modal de confirmación de eliminación
  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  // Cerrar el modal de confirmación de eliminación
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  // Confirmar eliminación
  const confirmDelete = async () => {
  var  API_URL = ip_back + '/api/usuarios/eliminar';
  var del_user=data.at(deleteIndex).usuario;
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "usuario" : del_user, "editor" : storedUser}),
        });
  
        if (response.ok) {
          setIsFormModalOpen(false); // Cierra el modal
        } else {
          console.error('Error al eliminar el usuario:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    fetchData();
    closeDeleteModal();
  };

  // Abrir el modal de confirmación de resetar contraseña
  const openResetPassword = (index) => {
    setResetPassdIndex(index);
    setIsResetPssdModalOpen(true);
  };

   // Cerrar el modal de confirmación de eliminación
   const closeResetPssdModal = () => {
    setIsResetPssdModalOpen(false);
  };

  // Confirmar Reset Pssd
  const confirmResetPssd = async () => {
    var  API_URL = ip_back + '/api/usuarios/reseteo_contrasena';
    var res_pssd_user=data.at(resetpassIndex).usuario;
        try {
          const token = JSON.parse(localStorage.getItem("token"));
          const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': api_key,
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ "usuario" : res_pssd_user, "editor" : storedUser}),
          });
    
          if (response.ok) {
            setIsFormModalOpen(false); // Cierra el modal
          } else {
            console.error('Error al resetear contraseña:', response.statusText);
          }
        } catch (error) {
          console.error('Error al hacer la solicitud:', error);
        }
      fetchData();
    closeResetPssdModal();
  };

  return (
    <div className="crud-table">
      {!loading && <button className='button_new' onClick={() => openFormModal()}>Añadir Nuevo Usuario</button>}
      {/* Tabla */}
      {loading ? <Spinner /> :
      <table>
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Correo</th>
            <th>Nombres</th>
            <th>Apellidos</th>
            <th>Identificacion</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index}>
                <td>{item.usuario}</td>
                <td>{item.email}</td>
                <td>{item.nombre}</td>
                <td>{item.apellido}</td>
                <td>{item.identificacion}</td>
                <td>
                  <button className="editar" onClick={() => openFormModal(index)}>Editar</button>
                  <button className="eliminar" onClick={() => openDeleteModal(index)}>Eliminar</button>
                  <button  onClick={() => openResetPassword(index)}>Resetear Contraseña</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No hay datos</td>
            </tr>
          )}
        </tbody>
      </table>
      }

      {/* Modal de Formulario */}
      {isFormModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>{isEditing ? 'Editar Usuario' : 'Añadir Usuario'}</h2>
            <form onSubmit={handleFormSubmit} className='form_crud'>
              <input
                type="text"
                name="usuario"
                placeholder="Nombre Usuario"
                value={formData.usuario}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Correo"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="nombre"
                placeholder="Nombres"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="apellido"
                placeholder="Apellidos"
                value={formData.apellido}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="identificacion"
                placeholder="Identificacion"
                value={formData.identificacion}
                onChange={handleChange}
                required
              />
              <button type="submit" className='guardar'>{isEditing ? 'Actualizar' : 'Añadir'}</button>
              <button type="button" className='cancelar' onClick={closeFormModal}>Cancelar</button>
            </form>
          </div>
          
        </div>
      )}

      {/* Modal de Confirmación de Eliminación */}
      {isDeleteModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmar Eliminación</h2>
            <p>¿Estás seguro de que deseas eliminar este registro?</p>
            <button onClick={confirmDelete}>Sí, eliminar</button>
            <button onClick={closeDeleteModal}>Cancelar</button>
          </div>
        </div>
      )}

      {/* Modal de Confirmación de Resetear Contraseña */}
      {isResetPssdModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmar Resetear Contraseña</h2>
            <p>¿Estás seguro de que deseas resetear la contraseña de este registro?</p>
            <button onClick={confirmResetPssd}>Sí, resetar</button>
            <button onClick={closeResetPssdModal}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CrudTable;